<template>
    <div class="row">
        <div class="col-12">
            <label class="form-label">Açıklama</label>
            <textarea class="form-control resize-none" rows="2" placeholder="Açıklama" v-model="value.Description"></textarea>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        value:Object
    }
}
</script>